export default function* failure({ error }) {}
